<template>
  <div id="liveStream">
    <BaseFormDevice @change-selected="changeSelectedDevice" @change-reload="changeReloadDevice"
                    @selectedAll="selectedAll"
                    @dataSearch="dataSearch"
                    :loadData="reloadDataDevice"></BaseFormDevice>

    <CButton class="mb-3" color="primary" :disabled="actionData.model.listDeviceSelectedCode.length === 0"
             @click="setupLiveStream()" ref="btnActionLiveStream">
      <i class="fa fa-microphone"></i>&nbsp;Thực hiện phát thanh
    </CButton>

    <CModal v-if="isShowMicrophoneLiveStream" title="Thực hiện phát thanh trực tiếp"
            :show.sync="isShowMicrophoneLiveStream" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <CCard class="content-fade-in mt-3p5">
            <CCardBody class="group-microphone text-center">
            <span style="display: flex;justify-content: center; font-weight: 500;font-size: 20px;">
              {{ volumeChangeMultipleDevice }}</span>
              <range-slider class="slider mb-4" min="0" max="100" step="5" v-model="volumeChangeMultipleDevice"
                            style="width: 100%;max-width: unset"
                            @change="changeVolume(null, volumeChangeMultipleDevice)">
              </range-slider>
              <div style="position: relative;">
                <i class="fa microphone" :class="!isMutedMicrophone ? 'fa-microphone' : 'fa-microphone-slash'"
                   :style="(liveStream && !isMutedMicrophone) ? 'color:#06e3e5' : 'color:black'"
                   @click="setupLiveStreamToDevice()">
                  <span v-if="liveStream" class="live-microphone">Live</span>
                  <CSpinner v-if="liveStream"
                            style="width:4rem;height:4rem;"
                            color="danger"
                            grow
                  />
                </i>

                <i style="position: absolute;bottom: 5px;"
                   :style="!liveStream ? 'pointer-events: none;color: #ababab;' : 'pointer-events: unset;color: unset;'"
                   :key="isMutedMicrophone" class="fa muted-microphone ml-4"
                   :class="isMutedMicrophone ? 'fa-microphone' : 'fa-microphone-slash'"
                   @click="submitMuteMicrophone()"></i>
              </div>
              <div class="loading-wrapper" v-if="loadingStartLivestream">
                <div class="sk-flow">
                  <div class="sk-flow-dot"></div>
                  <div class="sk-flow-dot"></div>
                  <div class="sk-flow-dot"></div>
                </div>
              </div>

              <span class="font-weight-bolder" v-if="isMutedMicrophone">
                Hiện tại microphone đang bị tắt, vui lòng bật lại để tiếp tục thực hiện phát trực tiếp!
              </span>

              <div class="mt-3">
                <audio id="audioRecord" ref="audioRecord" controls style="width: 300px;"></audio>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowMicrophoneLiveStream = false"><i
            class="fa fa-times"></i> Đóng
        </button>
      </template>
    </CModal>

    <CModal
        :title="generateModalConfirm(confirmOverrideScheduleEmergency.type)"
        :show.sync="confirmOverrideScheduleEmergency.isShowModal"
        :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          <!--          Xác nhận ghi đè lịch khẩn cấp được đặt từ cấp -->
          <template v-if="confirmOverrideScheduleEmergency.type == 0">
            Hiện tại đang phát bản tin khẩn cấp được gửi từ
            <span style="font-weight: 700;"> {{ confirmOverrideScheduleEmergency.locationName }}</span> bắt đầu từ
            <b>{{ confirmOverrideScheduleEmergency.startTime }}</b> và kết thúc lúc
            <b> {{ confirmOverrideScheduleEmergency.endTime }}</b> trên các thiết bị:
            <br/>
            <span v-for="i of confirmOverrideScheduleEmergency.devices">
            {{ i + ', ' }}
            </span>
            <span style="color: #ff0303; font-weight: bold;">
              (Chèn phát trực tiếp sẽ làm gián đoạn bản tin phát thanh khẩn cấp đang được đặt, vui lòng cân nhắc trước khi nhấn "Xác nhận")
            </span>
            <div>Bạn chắc chắn muốn chèn lịch khẩn cấp trên các thiết bị này?</div>
            <div>Nhấn <span class="text-modal-confirm">Xác nhận</span> để thực hiện.</div>
          </template>
          <!--          Xác nhận ghi đè lịch livestream -->
          <template v-else-if="confirmOverrideScheduleEmergency.type == 1">
            Hiện tại đang phát trực tiếp trên các thiết bị:
            <br/>
            <span v-for="i of confirmOverrideScheduleEmergency.devices">
              {{ i + ', ' }}
            </span>
            <span style="font-weight: bold;">
              (Việc chèn sẽ làm địa bàn đang phát trực tiếp bị gián đoạn, vui lòng cân nhắc trước khi nhấn "Xác nhận")
            </span>
            <div>Bạn chắc chắn muốn chèn sóng phát trực tiếp trên các thiết bị này?</div>
            <div>Nhấn <span class="text-modal-confirm">Xác nhận</span> để thực hiện.</div>
          </template>
          <!--          Thông báo đang có lịch livestream cùng cấp-->
          <template v-if="confirmOverrideScheduleEmergency.type == 2">
            Hiện tại đang có Cán bộ phát trực tiếp trên các thiết bị:
            <br/>
            <span v-for="i of confirmOverrideScheduleEmergency.devices">
             {{ i + ', ' }}
            </span>
            <div>Xin vui lòng thực hiện lại sau ít phút.</div>
          </template>
          <!--          Bị chèn sóng trực tiếp từ cấp trên -->
          <template v-if="confirmOverrideScheduleEmergency.type == 3">
            Nguyên nhân: Người dùng cấp trên đã chiếm quyền ưu tiên luồng phát trực tiếp theo phân cấp, phân quyền. Vui
            lòng thử lại sau!
          </template>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="closeOverrideScheduleEmergencyPlaying()"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitOverrideScheduleEmergencyPlaying()">
          <i class="fa fa-check"></i> Xác nhận
        </button>
      </template>
    </CModal>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import {DatePicker} from "v-calendar";
import BaseModal from "@/views/base/BaseModal";
import BaseFormDevice from "@/views/base/BaseFormDevice";
import {ACCESS_TOKEN_EXPIRED, ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME} from "@/constant";

export default {
  name: "Livestream",
  components: {
    BaseFormDevice,
    BaseModal,
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      timeout: 15000
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    return {
      loading: {value: false},
      reloadDataDevice: false,
      actionData: {
        model: {
          selectedAll: false,
          deviceSelectedId: null,
          deviceSelectedName: null,
          status: null,
          listDeviceSelectedCode: [],
          type: null,
          dataSearch: {}
        }
      },
      confirmOverrideScheduleEmergency: {
        isShowModal: false,
        playDate: '',
        startTime: '',
        endTime: '',
        devices: '',
        scheduleId: '',
        type: '',
        level: '',
        scheduleIdOverride: ''
      },
      volumeChangeMultipleDevice: 50,
      isShowMicrophoneLiveStream: false,
      loadingStartLivestream: false,
      liveStream: false,
      isMutedMicrophone: false,
      connectionsLiveStream: {},
      localStream: '',
      recorder: '',
      chunksRecorder: [],
      peerConnectionConfig: {
        'iceServers': [
          {'urls': 'stun:stun.l.google.com:19302'},
          {'url': 'turn:27.71.228.9:3478', username: 'test', credential: 'test123', password: 'test123'},
        ]
      },
      hasLiveStream: false,
      scheduleId: '',
      isRecording: false,
      isClickLivestream: false,
    }
  },
  methods: {
    generateModalConfirm(type) {
      if (type == 0) {
        return 'Xác nhận chèn lịch khẩn cấp';
      } else if (type == 1) {
        return 'Xác nhận chèn sóng phát trực tiếp';
      } else if (type == 2) {
        return 'Trùng lịch phát trực tiếp';
      } else if (type == 3) {
        return 'Phát trực tiếp bị gián đoạn';
      }
    },
    checkDeviceIsMobileOrTablet() {
      let check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    changeSelectedDevice(value) {
      this.actionData.model.listDeviceSelectedCode = value;
    },
    selectedAll(value) {
      this.actionData.model.selectedAll = value;
    },
    dataSearch(value) {
      this.actionData.model.dataSearch = value;
    },
    changeReloadDevice(value) {
      this.reloadDataDevice = value;
    },
    closeOverrideScheduleEmergencyPlaying() {
      this.confirmOverrideScheduleEmergency.isShowModal = false;
      this.isShowMicrophoneLiveStream = false;
    },
    submitOverrideScheduleEmergencyPlaying() {
      if (this.confirmOverrideScheduleEmergency.type == 0) {
        this.startLiveStream();
      } else if (this.confirmOverrideScheduleEmergency.type == 1) {
        this.startLiveStream();
      } else if (this.confirmOverrideScheduleEmergency.type == 2 || this.confirmOverrideScheduleEmergency.type == 3) {
        this.closeOverrideScheduleEmergencyPlaying();
      }
    },
    async getRealIp() {
      return new Promise((resolve, reject) => {
        $.getJSON("https://api.ipify.org?format=json", function (data) {
          resolve(data.ip);
        }).fail((err) => reject(err))
      })
    },

    setupSelectOneAction: function (actionTypeKey, deviceId, deviceName, status, type) {
      let actionData = this.actionData.model;
      actionData.deviceSelectedId = deviceId || null;
      actionData.deviceSelectedName = deviceName || null;
      actionData.status = status || null;
      actionData.type = type || null;
    },
    changeVolume(id, _volume) {
      let that = this;
      if ((id == '' || id == null) && (that.actionData.model.listDeviceSelectedCode.length == 0)) {
        this.showErrorMsg({message: 'Chưa có thiết bị nào được chọn'});
        return;
      }
      this.$helper.loadDataSource({
        url: "/devices/updateVolume",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: '',
            volume: _volume,
            deviceIds: that.actionData.model.listDeviceSelectedCode
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.isShowModalChangeVolumeMultipleDevice = false;
            if (that.actionData.model.listDeviceSelectedCode.length == 0) {
              that.showSuccessMsg({
                message: "Thay đổi âm lượng thành công"
              });
            }
            that.reloadDataDevice = true;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },

    submitRecord(_scheduleId, _base64) {
      let that = this;
      this.$helper.loadDataSource({
        url: "/livestream/saveRecord",
        dataSubmit: function () {
          return {
            scheduleId: _scheduleId,
            base64Recorder: _base64,
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {

          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },

    submitMuteMicrophone() {
      this.isMutedMicrophone = !this.isMutedMicrophone;
      this.localStream.getAudioTracks()[0].enabled = !this.isMutedMicrophone;
    },
    setupLiveStream() {
      let isMobileAndTablet = this.checkDeviceIsMobileOrTablet();
      if (isMobileAndTablet) {
        this.showErrorMsg({
          message: 'Hiện tại phát thanh trực tiếp chỉ hỗ trợ trên máy tính.' +
              ' Xin vui lòng dùng máy tính để tiếp tục thực hiện phát thanh trực tiếp. Xin cảm ơn'
        })
      } else {
        this.submitRefreshToken(true);
        // this.isShowMicrophoneLiveStream = true;
      }
    },
    setupLiveStreamToDevice() {
      let that = this;
      if (that.actionData.model.listDeviceSelectedCode.length == 0) {
        that.showErrorMsg({message: 'Chưa có thiết bị nào được chọn'});
        return;
      }
      if (!that.liveStream) {
        that.isClickLivestream = true;
        that.checkExitsScheduleEmergencyPlaying();
      } else {
        /* TODO Xử lý kết thúc Livestream tại đây */
        that.closeStream();
      }
    },
    checkExitsScheduleEmergencyPlaying() {
      let that = this;
      if (this.scheduleId == '' || this.scheduleId == null) {
        this.$sendMessageSocket("/app/check_schedule_emergency_livestream", JSON.stringify({
          deviceIds: this.actionData.model.listDeviceSelectedCode,
          searchDeviceModel: this.actionData.model.dataSearch,
          selectedAll: this.actionData.model.selectedAll
        }));
      }
    },
    async startLiveStream() {
      let that = this;
      var audio = that.$refs.audioRecord;
      audio.src = '';
      that.confirmOverrideScheduleEmergency.isShowModal = false;

      const constraint = {
        audio: {
          sampleSize: 16,
          echoCancellation: true,
          noiseSuppression: true,
          channelCount: 1
        }
      }

      // navigator.mediaDevices.getUserMedia({audio: true}).then((stream) => {
      navigator.mediaDevices.getUserMedia(constraint).then((stream) => {
        that.loadingStartLivestream = true;
        that.localStream = stream;
        that.getRealIp().then(res => {
          that.$sendMessageSocket("/app/schedule_livestream", JSON.stringify({
            deviceIds: that.actionData.model.listDeviceSelectedCode,
            scheduleIdExitsEmergencyPlaying: that.confirmOverrideScheduleEmergency.scheduleId,
            ipRequest: res,
            scheduleIdOverrideLiveStreamPlaying: that.confirmOverrideScheduleEmergency.scheduleIdOverride,
            searchDeviceModel: that.actionData.model.dataSearch,
            selectedAll: that.actionData.model.selectedAll
          }));
        }).catch(err => {
          that.$sendMessageSocket("/app/schedule_livestream", JSON.stringify({
            deviceIds: that.actionData.model.listDeviceSelectedCode,
            scheduleIdExitsEmergencyPlaying: that.confirmOverrideScheduleEmergency.scheduleId,
            scheduleIdOverrideLiveStreamPlaying: that.confirmOverrideScheduleEmergency.scheduleIdOverride,
            searchDeviceModel: that.actionData.model.dataSearch,
            selectedAll: that.actionData.model.selectedAll
          }));
        });
      }).catch((err) => {
        console.log(err)
        that.showErrorMsg({message: "Vui lòng cấp quyền sử dụng microphone để thao tác phát trực tiếp"})
      });
    },

    recordStream() {
      let that = this;
      that.recorder = new MediaRecorder(that.localStream);
      var blobObj;
      that.recorder.ondataavailable = (e) => {
        that.chunksRecorder.push(e.data);
        if (that.recorder.state === "inactive") {
          if (that.scheduleId && that.scheduleId !== '' && that.scheduleId !== null) {
            this.recorder = '';
            this.$sendMessageSocket("/app/livestream", JSON.stringify({
              type: "end",
              scheduleId: that.scheduleId,
            }));
            this.isRecording = false;
            let blob = new Blob(that.chunksRecorder, {type: "audio/mp3"});
            blobObj = blob;
            that.chunksRecorder = [];
            var audio = that.$refs.audioRecord;
            if (audio) {
              var blobURL = window.URL.createObjectURL(blob);
              audio.src = blobURL;
              audio.volume = 1;
              // audio.play();
            }

            /* Convert Blob to Base64 */
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
              var base64String = reader.result;
              // that.$sendMessageSocket("/app/livestream", JSON.stringify({
              //   type: "record",
              //   scheduleId: that.scheduleId,
              //   base64Recorder: base64String
              // }));
              that.submitRecord(that.scheduleId, base64String);
              that.scheduleId = '';
            }
            blobObj = null;
          }
        }
      };
      that.recorder.start();
    },

    closeStream() {
      if ((this.localStream !== null && this.localStream !== '') && this.localStream.getTracks().length > 0) {
        this.localStream.getTracks().forEach(each => {
          each.stop();
        })
      }
      for (const property in this.connectionsLiveStream) {
        const connection = this.connectionsLiveStream[property];
        connection.getSenders().forEach(sender => {
          sender.track.stop();
        })
        connection.close();
      }

      this.connectionsLiveStream = {};
      this.hasLiveStream = false;
      if (this.recorder != null && this.recorder != '') {
        if (this.recorder.state == 'recording') {
          this.recorder.stop();
        }
      } else {
        if (this.scheduleId) {
          this.$sendMessageSocket("/app/livestream", JSON.stringify({
            type: "end",
            scheduleId: this.scheduleId,
          }));
          this.scheduleId = "";
        }
      }
      this.liveStream = false;
      this.isMutedMicrophone = false;
      this.loadingStartLivestream = false;
      this.isClickLivestream = false;
    },

    handleStartLiveStreamSuccess(signal) {
      let that = this;
      that.$sendMessageSocket("/app/livestream", JSON.stringify({
        type: "init",
        scheduleId: signal.scheduleId,
        startTime: signal.startTime,
      }));
      that.scheduleId = signal.scheduleId;
    },

    handleInit(signal) {
      let that = this;
      var peerId = signal.sender;
      var connection = this.getRTCPeerConnectionObject(peerId);
      connection.createOffer().then(function (sdp) {
        connection.setLocalDescription(sdp).then(() => {
          that.$sendMessageSocket("/app/livestream", JSON.stringify({
            type: "offer",
            receiver: peerId,
            data: sdp,
            scheduleId: signal.scheduleId
          }));
        }).catch((err) => {
          console.log('Error set local description', err);
        })
      }).catch(function (e) {
        console.log('Error in offer creation.', e);
      });
    },

    handleOffer(signal) {
      let that = this;
      var peerId = signal.sender;
      var connection = this.getRTCPeerConnectionObject(peerId);
      connection.setRemoteDescription(new RTCSessionDescription(signal.data)).then(function () {
        // create an answer for the peedId.
        connection.createAnswer().then(function (answer) {
          connection.setLocalDescription(answer).then(() => {
            that.$sendMessageSocket("/app/livestream", JSON.stringify({
              type: "answer",
              receiver: peerId,
              data: answer,
              scheduleId: signal.scheduleId
            }));
            // if (!that.hasLiveStream) {
            //   // that.recordStream();
            //   that.loadingStartLivestream = false;
            //   that.liveStream = !that.liveStream
            //   that.hasLiveStream = true;
            // }
          }).catch((err) => {
            console.log('Error set local description', err);
          })
        }).catch(function (e) {
          console.log('Error in offer handling.', e);
        });
      }).catch(function (e) {
        console.log('Error in offer handling.', e);
      });
    },

    handleAnswer(signal) {
      var connection = this.getRTCPeerConnectionObject(signal.sender);
      // console.log(connection.remoteDescription)
      if (connection.remoteDescription != null) {
        connection.setRemoteDescription(new RTCSessionDescription(signal.data)).then(function () {
        }).catch(function (e) {
          console.log('Error in answer acceptance.', e);
        });
      }
    },

    handleIce(signal) {
      if (signal.data) {
        var connection = this.getRTCPeerConnectionObject(signal.sender);
        connection.addIceCandidate(new RTCIceCandidate(signal.data)).then(() => {
        }).catch((err) => {
              console.log("Error: " + err)
            }
        );
      }
    },

    getRTCPeerConnectionObject(sender) {
      let that = this;
      if (this.connectionsLiveStream[sender]) {
        return this.connectionsLiveStream[sender];
      }
      var connection = new RTCPeerConnection(this.peerConnectionConfig);
      // connection.addStream(that.localStream);
      // handle on ice candidate
      connection.onicecandidate = function (event) {
        if (event.candidate) {
          that.$sendMessageSocket("/app/livestream", JSON.stringify({
            type: "ice",
            receiver: sender,
            data: event.candidate,
            scheduleId: that.scheduleId
          }));
        }
      };
      connection.onicegatheringstatechange = async () => {
        // if (connection.iceGatheringState === "complete" && connectionInfo.current.answer) {
        if (connection.iceGatheringState === "complete") {
          // if (!that.isRecording) {
          //   that.recordStream();
          //   if (!that.hasLiveStream) {
          //     // that.recordStream();
          //     that.loadingStartLivestream = false;
          //     that.liveStream = !that.liveStream
          //     that.hasLiveStream = true;
          //   }
          // }
          // that.isRecording = true;
        }
      };

      connection.onconnectionstatechange = async () => {
        if (navigator.userAgent.indexOf('Chrome') !== -1 || navigator.userAgent.indexOf('Safari') !== -1) {
          if (connection.connectionState === 'connected') {
            if (!that.isRecording) {
              that.recordStream();
              if (!that.hasLiveStream) {
                that.loadingStartLivestream = false;
                that.liveStream = true;
                that.hasLiveStream = true;
              }
            }
            that.isRecording = true;
          }
        }
      }
      connection.oniceconnectionstatechange = async () => {
        if (navigator.userAgent.indexOf('Firefox') !== -1) {
          if (connection.iceConnectionState === 'connected') {
            if (!that.isRecording) {
              that.recordStream();
              if (!that.hasLiveStream) {
                that.loadingStartLivestream = false;
                that.liveStream = true;
                that.hasLiveStream = true;
              }
            }
            that.isRecording = true;
          }
        } else if (navigator.userAgent.indexOf('Chrome') !== -1) {

        } else if (navigator.userAgent.indexOf('Safari') !== -1) {

        } else if (navigator.userAgent.indexOf('Edge') !== -1 || navigator.userAgent.indexOf('Trident') !== -1) {

        } else {

        }
      }

      that.localStream.getTracks().forEach((track) => {
        connection.addTrack(track, that.localStream);
      });

      // connection.ontrack = async (event) => {
      //   console.log(event)
      //   // remoteStream.addTrack(event.track);
      // };

      // let the "negotiationneeded" event trigger offer generation
      connection.onnegotiationneeded = function () {
        connection.createOffer().then((sdp) => {
          connection.setLocalDescription(sdp).then(() => {
            that.$sendMessageSocket("/app/livestream", JSON.stringify({
              type: "offer",
              receiver: sender,
              data: sdp,
              scheduleId: that.scheduleId
            }));
          }).catch((err) => {
            console.log('Error set local description', err);
          })
        }).catch(function (e) {
          console.log('Error in offer creation.', e);
        });
      }

      // handle on track / onaddstream
      // connection.onaddstream = function (event) {
      //   console.log(event)
      // var audio = document.createElement("audio");
      // audio.autoplay = true;
      // audio.srcObject = event.stream;
      // };
      this.connectionsLiveStream[sender] = connection;
      return connection;
    },

    changeInputMicrophone() {
      let that = this;
      navigator.mediaDevices.enumerateDevices()
          .then((devices) => {
            var audio = devices.find(device => device.kind == "audioinput");
            if (audio) {
              var constraints = {
                // deviceId: {
                //     exact: devices[0].deviceId
                // },
                groupId: {
                  exact: audio.groupId
                }
              };
              return navigator.mediaDevices.getUserMedia({audio: constraints});
            }
          }).then(stream => {
        for (const property in that.connectionsLiveStream) {
          const connection = that.connectionsLiveStream[property];
          const audioTrack = connection.getSenders().find(sender => sender.track.kind === 'audio');
          audioTrack.track.stop();
          const newAudioTrack = stream.getAudioTracks()[0];
          var sender = connection.getSenders().find(function (s) {
            return s.track.kind == newAudioTrack.kind;
          });
          sender.replaceTrack(newAudioTrack);
        }
        that.localStream = stream;
      });
    },

    submitRefreshToken(isShowPopup) {
      let that = this;
      var refreshToken = localStorage.getItem(REFRESH_TOKEN_NAME);
      var expiredToken = localStorage.getItem(ACCESS_TOKEN_EXPIRED);
      var timeExpired = new Date(expiredToken * 1).getTime();
      var now = new Date().getTime();
      var minusExpired = Math.round((timeExpired - now) / 60000);
      if (minusExpired <= 5 && refreshToken) {
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/users/refresh",
          dataSubmit() {
            return {
              refresh_token: refreshToken,
            }
          },
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              localStorage.setItem(ACCESS_TOKEN_EXPIRED, response.data.data.expires_in);
              localStorage.setItem(REFRESH_TOKEN_NAME, response.data.data.refresh_token);
              localStorage.setItem(ACCESS_TOKEN_NAME, response.data.data.access_token);
              that.$disConnectSocket();
              that.$store.commit("set", ["reconnectSocket", true]);
              if (isShowPopup) {
                that.isShowMicrophoneLiveStream = true;
              }
            } else {
              that.$helper.setupErrorModel(response.data.data, that.$data);
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      } else {
        if (isShowPopup) {
          that.isShowMicrophoneLiveStream = true;
        }
      }
    },
  },
  created: function () {
  },
  mounted() {
    this.submitRefreshToken();

    window.addEventListener("beforeunload", () => {
      this.closeStream();
    })
    navigator.mediaDevices.ondevicechange = () => {
      if (this.hasLiveStream) {
        // if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        //   this.showErrorMsg({message: "Trình duyệt không hỗ trợ"})
        //   return;
        // }
        // this.changeInputMicrophone();
        this.showErrorMsg({
          message: "Thiết bị Microphone đang không được kết nối đến máy tính ( bị rút hoặc bị lỏng chân tiếp xúc với máy tính), vui lòng kiểm tra lại!"
        })
        this.closeStream();
      }
    }
  },
  watch: {
    '$store.state.liveStreamMessage': function (value) {
      // this.loadingStartLivestream = false;
      if (this.isClickLivestream) {
        if (value && value.returnCode == 0) {
          if (value.data.type == 0) {     // Cần confirm vì có bản tin khẩn cấp từ cấp trên đang phát
            this.confirmOverrideScheduleEmergency = {
              isShowModal: true,
              devices: value.data.devices,
              locationName: value.data.locationName,
              startTime: value.data.startTime,
              endTime: value.data.endTime,
              scheduleId: value.data.id,
              type: 0
            }
          } else if (value.data.type == 1) {    // Confirm ghi đè phát livestream với cấp cao hơn
            this.confirmOverrideScheduleEmergency = {
              isShowModal: true,
              devices: value.data.devices,
              level: value.data.level,
              scheduleIdOverride: value.data.scheduleId,
              type: 1
            }
          } else if (value.data.type == 2) {    // Thông báo thiết bị đang phát livestream với ngang cấp
            this.confirmOverrideScheduleEmergency = {
              isShowModal: true,
              devices: value.data.devices,
              level: value.data.level,
              type: 2
            }
          } else if (value.data.type == 3) {    // STOP khi bị ghi đè lịch trực tiếp từ cấp trên
            this.closeStream();
            this.confirmOverrideScheduleEmergency = {
              isShowModal: true,
              level: value.data.level,
              type: 3
            }
          }
        } else if (value.returnCode == 1) {     // Tạo lịch Stream thành công
          let data = value.data;
          switch (data.type) {
            case 'check_emergency_success':
              this.startLiveStream();
              break;
            case 'start_success':
              this.handleStartLiveStreamSuccess(data);
              break;
            case 'init':
              this.handleInit(data);
              break;
            case 'offer':
              this.handleOffer(data);
              break;
            case 'answer':
              this.handleAnswer(data);
              break;
            case 'ice':
              this.handleIce(data);
              break;
          }
        } else {
          this.$router.push("/errors/500");
        }
      }
    },
    isShowMicrophoneLiveStream(value) {
      if (!value) {
        this.closeStream();
      }
    },
    '$store.state.isBlockUser': function (value) {
      debugger
      if (value) {
        this.closeStream();
      }
    }
  },
  computed: {},
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.closeStream);
  }
};
</script>
<style>
@import '~spinkit/spinkit.min.css';
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

#liveStream {
  .spinner-grow {
    position: absolute;
    z-index: -1;
    left: 0;
    animation: spinner-grow 1s linear infinite;
    background: #e53232 !important;
  }

  .loading-wrapper {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .slider {
    width: 200px;
    max-width: 200px;
    //padding: 0 !important;
  }

  .range-slider-rail, .range-slider-fill {
    height: 6px !important;
  }

  .range-slider-fill {
    background-color: #0b98ff;
  }

  .range-slider-knob {
    width: 15px !important;
    height: 15px !important;
  }

  .range-slider {
    padding: unset !important;
  }

  .dropdown-volume {
    padding: unset;
    border-radius: 50px;
  }

  .dropdown-volume a:hover {
    background: none !important;
  }

  .custom-toggle-volume {
    min-width: 70px;
    display: inline-flex !important;
    justify-content: center;
  }

  .volume .dropdown {
    display: inline-flex !important;
  }

  .action-custom {
    height: 200px;
    overflow: auto;
  }

  .group-btn-action {
    height: 35px;
  }

  .group-btn-action:hover {
    background: unset !important;
  }


  .microphone {
    position: relative;
    font-size: 100px;
    cursor: pointer;
  }

  .live-microphone {
    position: absolute;
    font-size: 13px;
    border: 1px solid red;
    padding: 3px 5px 3px 5px;
    border-radius: 25px;
    color: white;
    background: red;
    font-weight: bold;
    right: -25px;
    top: -11px;
    -webkit-animation: flickerAnimation 1s linear infinite;
    -moz-animation: flickerAnimation 1s linear infinite;
    -o-animation: flickerAnimation 1s linear infinite;
    animation: flickerAnimation 1s linear infinite;
  }

  .muted-microphone {
    font-size: 30px;
    cursor: pointer;
  }

}

@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


</style>
